import openinghourShorten from 'openinghour-shorten';

interface Hours {
  open: { day: number; time: string };
  close?: { day: number; time: string };
}

export type HoursOfOperation = Hours[];

export const formatHoursOfOperation = (
  operatingHours: HoursOfOperation | null | undefined
): string[] | null => {
  if (Array.isArray(operatingHours) && operatingHours.length > 0) {
    const hours = (openinghourShorten(operatingHours, {
      startByMonday: true,
      format12Hr: true,
    }) as string)
      .split('; ')
      .map((h) =>
        h
          .replace(/ (\d)/, ': $1')
          .replace('~', ' – ')
          .replace(',', ', ')
          .replace(/0(\d):/g, '$1:')
      );

    return hours && hours.length ? hours : null;
  }

  return null;
};
